import { render, staticRenderFns } from "./TradeImports.vue?vue&type=template&id=2c2ebe17&scoped=true&"
import script from "./TradeImports.vue?vue&type=script&lang=js&"
export * from "./TradeImports.vue?vue&type=script&lang=js&"
import style0 from "./TradeImports.vue?vue&type=style&index=0&id=2c2ebe17&lang=scss&scoped=true&"
import style1 from "./TradeImports.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c2ebe17",
  null
  
)

export default component.exports